module.exports = __webpack_public_path__ + "img/113.cd79d749.jpg";